import { render, staticRenderFns } from "./topControllerInsertion.vue?vue&type=template&id=535fe334&"
import script from "./topControllerInsertion.vue?vue&type=script&lang=ts&"
export * from "./topControllerInsertion.vue?vue&type=script&lang=ts&"
import style0 from "./topControllerInsertion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports